module.exports = __webpack_public_path__ + "static/img/H9_1.1547c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H9_1.png
// module id = ewgb
// module chunks = 0